import { IOutletInner } from '../models';

export const isNationalAccount = (account?: IOutletInner, equipmentTypeId?: number): boolean => {
  if (account && equipmentTypeId) {
    return account?.acn ? true : false;
  }
  return false;
};

export const isNationalAccountForNotListed = (account?: IOutletInner): boolean => {
  if (account) {
    return account?.marketingId && account?.marketingId?.charAt(0) !== '2' ? true : false;
  }
  return false;
};
